























































import ProductWidget from '@/components/widgets/ProductWidget.vue';
import { default as Component } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import HsgProductInfoWidget from '@/components/widgets/hsg/HsgProductInfoWidget.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Tracking from '@/interfaces/Tracking';

import Format from '@/interfaces/Format';

import ProductData from '@/interfaces/ProductData';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  props: {
    availableProducts: {},
    loadingProducts: {},
    defaultAddons: Array,
    isMobile: Boolean
  },
  components: {
    'product-info': HsgProductInfoWidget
  },
  filters: {
    euro: formatProvider.euro()
  }
})
export default class HsgProductWidget extends ProductWidget {
  protected tariffsNotAvailable = false;

  @Watch('products')
  public productsLoaded(products: []): void {
    this.tariffsNotAvailable = products.length === 0;
    if (products.length > 0) {
      trackingProvider.productsLoaded(this.sessionState, products);
    }
  }

  get products(): ProductData[] {
    const sorting = [
      'PRODVolkswagenNaturstromBlue',
      'PRODVolkswagenNaturstromClassic',
      'PRODVolkswagenNaturstromConnect'
    ];
    const products = this.$props.availableProducts.slice(0, 3);
    return this.mapOrder(products, sorting, 'productCode');
  }

  public getUrl(text: string): string {
    if (text) {
      const regex =
        // eslint-disable-next-line no-useless-escape
        /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
      const results = text.match(regex);
      return results ? results[0] : '';
    }

    return '';
  }

  protected getDisclaimer(product: { totalBasePriceBruttoMonth: number }): string {
    const converter = formatProvider.euro();
    return this.$t('product.widget.tariff.information.disclaimer', {
      zip: this.sessionState.zip,
      usage: this.sessionState.usage,
      price: converter(product.totalBasePriceBruttoMonth)
    }).toString();
  }

  protected mapOrder(array: [], order: string[], key: string): [] {
    array.sort((a, b) => {
      const A = a[key];
      const B = b[key];

      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });

    return array;
  }
}
